<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/uia7sy/tc-custom/9781455602841.jpg?1702063706173" alt="This image is the cover for the book Confederate Women"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Confederate Women
      </h1>
      <p class="bookDescription body article font2">
        <p><b>True stories of Southern women in the Civil War </b><b>for “any reader with an interest in women’s history . . . An eye-opening experience.” —<i>ForeWord</i></b></p><p> The women featured in this anthology refute the common belief that Southern women were delicate and fragile. These Confederate women started relief organizations and militia companies, learned how to fire a musket, and even worked as spies. One courageous woman disguised herself as a male officer and recruited troops from around the South. </p><p><i>Confederate Women</i> includes ten essays about the crucial role Southern women played during and after the Civil War, believing that the war was “certainly ours as well as that of the men.” Excerpts from correspondence with their sons, fathers, husbands, and other women shed light on their unique position in America’s past. Often women are left out of history books, only to fade into the shadows of time. Thanks to Mauriel Phillips Joslyn and her contributing authors, these women will remain a part of history, never to be forgotten. </p><p> “An affecting reminder that Southern women faced the challenges of the wartime era with courage and determination.” —<i>Civil War News</i></p><p><i>Previously published as</i> Valor and Lace: The Roles of Confederate Women 1861–1865 </p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Mauriel Phillips Joslyn
      </h2>
      
      <p class="authorDescription body article">Mauriel Phillips Joslyn was born in Manchester, Georgia, and earned undergraduate and graduate degrees in history. While living in Virginia, Joslyn and her family participated in numerous Civil War reenactments. Joslyn lectures and gives presentations on military history dressed in full Confederate costume. She has written several articles about the Civil War and has been published in Gettysburg Magazine, Military Heritage, Georgia Journal, and Irish Sword. Joslyn currently lives in Sparta, Georgia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03e1189c